import { render, staticRenderFns } from "./LbHalfView.vue?vue&type=template&id=e2f3c4c0&scoped=true"
import script from "./LbHalfView.vue?vue&type=script&lang=js"
export * from "./LbHalfView.vue?vue&type=script&lang=js"
import style0 from "./LbHalfView.vue?vue&type=style&index=0&id=e2f3c4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f3c4c0",
  null
  
)

export default component.exports